import { clients } from '@oncolens/oncolens-ui/lib/api/client';

const getDateOnly = (date: Date) =>
  `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

export function getReportData(organizationId: string, startDate: Date, endDate: Date) {
  return clients.domain.get(
    `/reports/behaviorconfigtrackings/OrgByDateRange?organizationId=${organizationId}&startDate=${getDateOnly(
      startDate,
    )}&endDate=${getDateOnly(endDate)}`,
    {
      responseType: 'blob',
    },
  );
}
